import React from "react"
import { Container, Row, Col, Nav, NavItem } from "reactstrap"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import { NavLink, Outlet } from "react-router-dom"
import { t } from "i18next"

const UserProfilePage = () => {
  //meta title
  document.title = "Profile | teleman"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={t("home")} breadcrumbItem={t("profile")} />
          <Row>
            <Col md="3">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    to=""
                    end
                    style={{ cursor: "pointer" }}
                    className={"mb-2 card box-center nav-link"}
                  >
                    <i className="bx bx-user display-5"></i>
                    <p className="h5 mb-0">{t("profile")}</p>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    to="security"
                    style={{ cursor: "pointer" }}
                    className={"mb-2 card box-center nav-link"}
                  >
                    <i className="bx bx-check-shield display-5"></i>
                    <p className="h5 mb-0">{t("security")}</p>
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="9">
              <Outlet />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserProfilePage
